//
import MapNavigator from '../../common/mapNavigator'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js'

export default {
  name: 'StationMap',
  data () {
    return {
      defaultMapId: 0,
      defaultRegionId: 0,
      defaultSystemKind: 0,
      rootMapRequired: true
    }
  },
  components: {
    MapNavigator
  },
  mixins: [
    ssoLoginMixin
  ],
  watch: {
    // 观察路由是否发生变化（处理组件相同path不同情况下页面无法正常切换问题）
    // from 对象中包含当前地址
    // to 对象中包含目标地址
    // 其实还有一个next参数的，这个参数是控制路由是否跳转的，如果没写，可以不用写next()来代表允许路由跳转，如果写了就必须写next(),否则路由是不会生效的。
    '$route': function(to, from) {
      if (to.path !== from.path) {
        let dataChanged = false
        if (this.$route.query.mapId && this.$route.query.mapId !== this.defaultMapId) {
          this.defaultMapId = this.$route.query.mapId
          dataChanged = true
        }
        if (this.$route.query.regionId && this.$route.query.regionId !== this.defaultRegionId) {
          this.defaultRegionId = this.$route.query.regionId
          dataChanged = true
        }
        if (this.$route.query.systemKind && this.$route.query.systemKind !== this.defaultSystemKind) {
          this.defaultSystemKind = this.$route.query.systemKind
          dataChanged = true
        }
        if (this.$route.query.rootMapRequired && this.$route.query.rootMapRequired !== this.rootMapRequired) {
          this.rootMapRequired = this.$route.query.rootMapRequired
          dataChanged = true
        }
        if (dataChanged) { // 切换地图
          this.switchMap(this.defaultMapId, this.defaultRegionId, this.defaultSystemKind)
        }
      }
    }
  },
  created() {
    if (this.$route.query.mapId) {
      this.defaultMapId = this.$route.query.mapId
    }
    if (this.$route.query.regionId) {
      this.defaultRegionId = this.$route.query.regionId
    }
    if (this.$route.query.systemKind) {
      this.defaultSystemKind = this.$route.query.systemKind
    }
    if (this.$route.query.rootMapRequired) {
      this.rootMapRequired = this.$route.query.rootMapRequired
    }
  },
  mounted() {
  },
  methods: {
    // 切换地图
    switchMap(mapId, regionId, systemKind) {
      this.$refs.mapNavigator.switchMap(mapId, regionId, systemKind)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/monitoring/StationMap/StationMap.js